'use strict';

(function (angular) {
  angular.module('zp').service('authService', authService);

  /**@ngInject */
  function authService($q, $rootScope, config, $localStorage, UserModel, zpAPI) {
    var service = this;

    //public methods
    service.init = init;
    service.login = login;
    service.logout = logout;
    service.getCurrentUser = getCurrentUser;
    service.isUserLoggedIn = isUserLoggedIn;
    service.register = register;
    service.update = update;

    //////////////////////////////////

    function init() {
      return $q.when(function () {
        if (!!$localStorage.currentUser) {
          return setCurrentUser($localStorage.currentUser);
        }
        return true;
      }());
    }

    function register(email, password, name) {
      return zpAPI.http({
        method: 'POST',
        url: config.zpAPI.defaultRoutes.USERS + '/register',
        data: {
          email: email,
          password: password,
          name: name
        }
      }).then(function (response) {
        var u = new UserModel(response);
        setCurrentUser(u);
        return u;
      });
    }

    function update(user) {
      return zpAPI.http({
        method: 'PUT',
        url: config.zpAPI.defaultRoutes.USERS + '/' + user.id,
        data: user
      }).then(function (response) {
        return new UserModel(response);
      });
    }

    function isUserLoggedIn() {
      return !!$localStorage.currentUser;
    }

    function login(email, password) {
      return zpAPI.http({
        method: 'POST',
        url: config.zpAPI.defaultRoutes.USERS + '/login',
        data: {
          email: email,
          password: password
        }
      }).then(function (response) {
        var u = new UserModel(response);
        setCurrentUser(u);
        return u;
      });
    }

    function logout() {
      return $q.when(function () {
        delete $localStorage.currentUser;
        delete $rootScope.currentUser;
        return true;
      }());
    }

    function getCurrentUser() {
      return $q.when(function () {
        if (!!$localStorage.currentUser) {
          return $localStorage.currentUser;
        }
        return null;
      }());
    }

    function setCurrentUser(userData) {
      var userModel = new UserModel(userData);
      $localStorage.currentUser = userModel;
      $rootScope.currentUser = userModel;
      $rootScope.$watch('currentUser', function () {
        $localStorage.currentUser = $rootScope.currentUser;
      }, true);
      return userModel;
    }
  }
})(window.angular);